import { render } from "./MenuNavbar.vue?vue&type=template&id=7890373d&scoped=true"
import script from "./MenuNavbar.vue?vue&type=script&lang=js"
export * from "./MenuNavbar.vue?vue&type=script&lang=js"

import "./MenuNavbar.vue?vue&type=style&index=0&id=7890373d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-webapp/frontend-webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7890373d"]])

export default __exports__